import { Pipe, PipeTransform } from '@angular/core';
import { JobId } from '../services/data/models/jobs/job-id';

@Pipe({ name: 'jobId' })
export class BiJobIdPipe implements PipeTransform {
    transform(jobId: JobId): string | null {
        return `${jobId.Project}.${jobId.Category}.${jobId.Name}`;
    }
}
